import { connect } from 'react-redux';
import HomeView from './components/HomeView';
import {
  getCurrentUser,
  sendOtp,
  resetByAnswer,
  resetByOtp,
  getConfiguration
} from '../../authentication/actions';

const mapDispatchToProps = {
  getCurrentUser,
  sendOtp,
  resetByAnswer,
  resetByOtp,
  getConfiguration
}

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeView);
